/* tslint:disable */
import { Action } from '@ngrx/store';

export const LOAD_POSTSECONDARY_CALCUALTED_FIELDS = '[Portal] Load Postsecondary Calculated Fields with GraphQL';
export const LOAD_POSTSECONDARY_CALCULATED_FIELDS_FAIL = '[Portal] Load Postsecondary Calculated Fields Fail';
export const LOAD_POSTSECONDARY_CALCULATED_FIELDS_SUCCESS = '[Portal] Load Postsecondary Calculated Fields Success';

export const UPDATE_POSTSECONDARY_STUDENTS_CALCULATED_FIELDS_SUCCESS =
  '[Portal] Update Postsecondary Students Calculated Fields Success';
export const UPDATE_POSTSECONDARY_STUDENTS_CALCULATED_FIELDS_FAIL =
  '[Portal] Update Postsecondary Students Calculated Fields Fail';

export class LoadPostsecondaryCalculatedFields implements Action {
  readonly type = LOAD_POSTSECONDARY_CALCUALTED_FIELDS;
  constructor(public payload: any) {}
}
export class LoadPostsecondaryCalculatedFieldsSuccess implements Action {
  readonly type = LOAD_POSTSECONDARY_CALCULATED_FIELDS_SUCCESS;
  constructor(public payload: any) {}
}

export class LoadPostsecondaryCalculatedFieldsFail implements Action {
  readonly type = LOAD_POSTSECONDARY_CALCULATED_FIELDS_FAIL;
  constructor(public payload: any) {}
}
export class UpdatePostsecondaryStudentCalculatedFieldsSuccess implements Action {
  readonly type = UPDATE_POSTSECONDARY_STUDENTS_CALCULATED_FIELDS_SUCCESS;
  constructor(public payload: any) {}
}

export class UpdatePostsecondaryStudentCalculatedFieldsFail implements Action {
  readonly type = UPDATE_POSTSECONDARY_STUDENTS_CALCULATED_FIELDS_FAIL;
  constructor(public payload: any) {}
}

export type CalculatedFieldsActions =
  | LoadPostsecondaryCalculatedFields
  | LoadPostsecondaryCalculatedFieldsSuccess
  | LoadPostsecondaryCalculatedFieldsFail
  | UpdatePostsecondaryStudentCalculatedFieldsSuccess
  | UpdatePostsecondaryStudentCalculatedFieldsFail;
